<template>
  <div class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card">
    <div class="card card-bio-content card--interactive text-center">
      <div @click.stop>
        <DotPopper
          v-can="'edit-profiles'"
          :options="{ placement: 'bottom-end' }"
        >
          <div
            slot="content"
            class="flex flex-col"
          >
            <a
              :href="submissionsLink"
              v-text="'View Submissions'"
            />
          </div>
        </DotPopper>
      </div>
      <h3 class="mb-4">
        <a
          :href="formLink"
          class="no-underline"
          v-text="form.attributes.title"
        />
      </h3>
      <button
        type="button"
        class="btn btn--sm btn--icon-only icon icon--small"
        @click="visitForm"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="15"
          viewBox="0 0 9 15"
        >
          <path d="M7.67 2.48l.66-1.23L6.25.21 5.56 1.5zm-2.35-.54L.48 10.95l2.11.98 4.84-9.01zM.31 11.43L.1 14.11l2.21-1.75z" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script type="text/babel">
import DotPopper from 'Base/Resources/assets/js/components/DotPopper'

export default {
  name: 'FormListItem',
  components: {
    DotPopper,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      return this.form.attributes.title
    },
    submissionsLink() {
      return this.$urlGenerator.active(`forms/${this.form.uuid}/submissions`)
    },
    formLink(){
      return this.$urlGenerator.active(`forms/${this.form.uuid}`)
    },
  },
  methods: {
    visitForm(){
      window.location = this.formLink
    },
  },
}
</script>
